import { render, staticRenderFns } from "./Postalcode.vue?vue&type=template&id=4067ae0c"
import script from "./Postalcode.vue?vue&type=script&lang=js"
export * from "./Postalcode.vue?vue&type=script&lang=js"
import style0 from "./Postalcode.vue?vue&type=style&index=0&id=4067ae0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports